/**
 * Reward ladder — unlock celebration.
 *
 * Progressive enhancement only. The ladder itself is server-rendered Liquid and
 * is fully correct with this file blocked or absent; all this adds is a pop on
 * the milestone at the moment it is earned.
 *
 * The mini cart is replaced wholesale on every cart change (?view=mini-cart), so
 * "how many tiers were unlocked a moment ago" cannot live on the element. It is
 * kept in sessionStorage and compared after each re-render.
 *
 * The same moment is the one GA4 wants: when the shipping rung goes from
 * locked to unlocked, a free_shipping_unlocked event is sent through the gtag
 * the layout defines, with the threshold as its value, so the funnel (how many
 * carts cross the line, and what they do next) can be read outside Shopify's
 * reports. Only the first rung counts -- the upper rungs are merchant rewards
 * -- and only a crossing, never a page that loads already over the line. With
 * gtag absent (blocked, or a store without the tag) nothing is sent and the
 * celebration is unaffected.
 */
(function () {
  'use strict';

  var STORE_KEY = 'suzies:rewardLadder:unlocked';
  var CELEBRATE_MS = 750;

  function readPrevious() {
    try {
      var raw = window.sessionStorage.getItem(STORE_KEY);
      return raw === null ? null : parseInt(raw, 10);
    } catch (e) {
      return null; // private mode / storage disabled
    }
  }

  function writePrevious(value) {
    try {
      window.sessionStorage.setItem(STORE_KEY, String(value));
    } catch (e) {
      /* nothing to do — celebration is optional */
    }
  }

  function reportFreeShippingUnlocked(ladder) {
    var thresholdCents = parseInt(ladder.getAttribute('data-free-shipping-cents'), 10);
    // A ladder of merchant rewards only has no shipping rung to cross.
    if (!thresholdCents || thresholdCents <= 0) return;
    if (typeof window.gtag !== 'function') return;

    var cartCents = parseInt(ladder.getAttribute('data-cart-cents'), 10);
    var params = {
      value: thresholdCents / 100,
      cart_value: isNaN(cartCents) ? undefined : cartCents / 100
    };
    var currency = ladder.getAttribute('data-currency');
    if (currency) params.currency = currency;

    try {
      window.gtag('event', 'free_shipping_unlocked', params);
    } catch (e) {
      /* analytics must never break the cart */
    }
  }

  function sync() {
    var ladders = document.querySelectorAll('[data-reward-ladder]');
    if (!ladders.length) return;

    var current = parseInt(ladders[0].getAttribute('data-unlocked-count'), 10);
    if (isNaN(current)) return;

    var previous = readPrevious();
    writePrevious(current);

    // First sight of the ladder this session establishes the baseline: landing
    // on a cart that already qualifies is not an unlock.
    if (previous === null || current <= previous) return;

    if (previous < 1 && current >= 1) {
      reportFreeShippingUnlocked(ladders[0]);
    }

    Array.prototype.forEach.call(ladders, function (ladder) {
      ladder.classList.add('is-celebrating');
      window.setTimeout(function () {
        ladder.classList.remove('is-celebrating');
      }, CELEBRATE_MS);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  // Fired by theme.js once replacement cart markup is in the DOM.
  document.documentElement.addEventListener('cart:rerendered', sync);
})();
